<div class="text-center">
  <button type="button" (click)="openJsonModal(jsonModal)" class="btn btn-outline-primary">View details...</button>
</div>


<ng-template #jsonModal let-modal>
  <div class="modal-header bg-primary text-white fw-bold">
    <h5 class="modal-title"><i class="bi bi-eye"></i> Change Details</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Link to the main record -->
    <div *ngIf="recordUrl && fullRowData.operation !== 'Deleted'">
      <a [routerLink]="recordUrl" class="btn btn-link text-primary" (click)="modal.dismiss()">
        <i class="bi bi-box-arrow-up-right"></i> View Record
      </a>
    </div>

    <div class="mb-3 p-3 border rounded bg-light">
      <div><strong>Id:</strong> {{ fullRowData.id }}</div>
      <div><strong>Created By:</strong> {{ createdBy }}</div>
      <div><strong>Created Date:</strong> {{ createdDate }}</div>
      <div *ngIf="modifiedBy && modifiedBy !== 'NULL'"><strong>Modified By:</strong> {{ modifiedBy }}</div>
      <div *ngIf="modifiedDate && modifiedBy !== 'NULL'"><strong>Modified Date:</strong> {{ modifiedDate }}</div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-bordered fs-6">
        <thead class="table-light">
          <tr>
            <th>Field</th>
            <th>Old Value</th>
            <th>New Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let key of displayedFields" [ngClass]="{'table-warning': isChanged(key)}">
            <td><strong>{{ friendlyNames[key] || key }}</strong></td> <!-- ✅ Friendly Name -->
            <td><span class="text-danger">{{ parsedOldValues[key] ?? 'N/A' }}</span></td>
            <td>
              <span *ngIf="fullRowData.operation !== 'Deleted'" class="text-success">{{ parsedNewValues[key] ?? 'N/A'}}</span>
              <span *ngIf="fullRowData.operation === 'Deleted'" class="text-muted">Deleted</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>